<template>
  <div>
    <div v-if="isSpotlightsLoaded">
      <div v-html="spotlights.content.rendered"></div>
    </div>
    <div class="container" id="all-events">
      <div class="row mb-3" v-if="!isEventsLoaded">
        <div class="col-12 col-md-6 col-lg-4 placeholder" v-for="index in 6" :key="index">
          <div class="blog-article">
            <div class="thumbnail mb-3"></div>
            <div class="paragraph mb-4" style="width: 30%;"></div>
            <div class="paragraph mb-2" style="width: 100%;"></div>
            <div class="paragraph" style="width: 80%;"></div>
          </div>
        </div>
      </div>

      <div v-if="events.length">
        <div class="separate"></div>

        <h1 class="page-title text-center mt-5">Recent Events</h1>
        <h2 class="sub-title text-center mb-5" v-html="$t('message.allevents')"></h2>

        <div class="row mb-3" v-if="isEventsLoaded">
          <div class="col-12 col-md-6 col-lg-4" v-for="(event, key) in events" :key="key">
            <router-link :to="{ name: event.type, params: { slug: event.slug } }">
              <div class="blog-article">
                <div class="thumbnail">
                  <div
                    class="thumbnail-media"
                    v-lazy-container="{ selector: 'img' }"
                    v-if="event._embedded"
                  >
                    <img
                      :data-src="`${event._embedded['wp:featuredmedia'][0].media_details.sizes['post-thumbnail'].source_url}`"
                      :data-srcset="`${event._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url} 2x`"
                      class="d-block m-auto"
                    />
                  </div>
                  <!-- /.thumbnail-media -->
                </div>
                <!-- /.thumbnail -->
                <div class="blog-desc">
                  <div class="category">กิจกรรม</div>
                  <div class="description" v-html="event.title.rendered"></div>
                </div>
                <!-- /.blog-desc -->
              </div>
              <!-- /.blog-article -->
            </router-link>
          </div>
        </div>
        <!-- /.row -->

        <div class="row mb-5">
          <div class="col text-center">
            <router-link
              :to="{ name: 'EventLanding' }"
              class="btn dark"
              v-html="$t('message.viewmore')"
            ></router-link>
          </div>
        </div>
        <!-- /.row -->
      </div>

    </div>
    <!-- /.container -->
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Home',
  data () {
    return {
      title: process.env.VUE_APP_TITLE,
      api_path: process.env.VUE_APP_API_PATH,
      spotlights: [],
      isSpotlightsLoaded: false,
      events: [],
      isEventsLoaded: false
    }
  },
  created () {
    document.title = this.title
  },
  mounted () {
    this.getSpotlights()
    this.getEvents()
  },
  methods: {
    getSpotlights () {
      const lang = this.$route.params.lang
      const $vm = this
      $vm.isSpotlightsLoaded = false
      axios
        .get(`${this.api_path}wp-json/wp/v2/pages`, {
          params: {
            slug: 'home',
            lang
          }
        })
        .then(res => {
          if (res.data) {
            $vm.spotlights = res.data[0]
            $vm.isSpotlightsLoaded = true
          }
        })
    },
    getEvents () {
      const lang = this.$route.params.lang
      const $vm = this
      axios
        .get(`${this.api_path}wp-json/wp/v2/event`, {
          params: {
            lang,
            _embed: true,
            per_page: 6
          }
        })
        .then(res => {
          if (res.data) {
            $vm.events = res.data
            $vm.isEventsLoaded = true
          }
        })
    }
  }
}
</script>
